export const MARKET_TIME_RANGES = ['1H', '6H', '1D', '1W', '1M', 'ALL'] as const;

export type MarketTimeRange = (typeof MARKET_TIME_RANGES)[number];

export const DEFAULT_SELECTED_RANGE: MarketTimeRange =
  MARKET_TIME_RANGES[MARKET_TIME_RANGES.length - 1];

export const TRADE_SIDES = {
  YES: 'yes',
  NO: 'no',
} as const;

export const DEFAULT_TRADE_SIDE = TRADE_SIDES.YES;

export const UMA_RESOLUTION_STATUS = {
  RESOLVED: 'resolved',
  PROPOSED: 'proposed',
} as const;

export const EXPIRATION_OPTIONS = [
  { label: '1m', value: '1m', seconds: 60 },
  { label: '5m', value: '5m', seconds: 300 },
  { label: '1h', value: '1h', seconds: 3600 },
  { label: '12h', value: '12h', seconds: 12 * 3600 },
  { label: '24h', value: '24h', seconds: 24 * 3600 },
  { label: 'End of Day', value: 'end-of-day' },
] as const;

export type ExpirationValue = (typeof EXPIRATION_OPTIONS)[number]['value'];

export const calculateExpirationTimestamp = (value: string): number => {
  const now = Math.floor(Date.now() / 1000);
  const buffer = 60; // 1 minute security threshold

  if (value === 'end-of-day') {
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
    return Math.floor(endOfDay.getTime() / 1000);
  }

  const option = EXPIRATION_OPTIONS.find((opt) => opt.value === value);
  const seconds = (option as any)?.seconds ?? 3600;

  return now + buffer + seconds;
};
